import {
  IAssetTypeImportResponse,
  IImportResultSummary,
  IPreviewRow,
  TImportResultStatus,
} from './i-asset-type-import';

export const applyImportResults = (
  rows: IPreviewRow[],
  response: IAssetTypeImportResponse,
): { rows: IPreviewRow[]; summary: IImportResultSummary } => {
  const results = response.results ?? [];
  const byRowId = new Map(results.map((result) => [result.rowId, result]));

  const merged = rows.map((row) => {
    const result = byRowId.get(row.key);
    if (!result) {
      return row;
    }
    return {
      ...row,
      status: result.status,
      serverMessage: result.message,
      createdId: result.id,
    };
  });

  const countOf = (status: TImportResultStatus): number => (
    results.filter((result) => result.status === status).length
  );

  return {
    rows: merged,
    summary: {
      total: response.total ?? results.length,
      created: response.created ?? countOf('created'),
      updated: response.updated ?? countOf('updated'),
      skipped: response.skipped ?? countOf('duplicate'),
      failed: response.failed ?? countOf('failed'),
    },
  };
};
